export const CutReceiptIcon = ({ className }) => {
  return (
  <svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_6772_140962)">
      <path
        d="M10.625 13.8125H23.375"
        stroke="black"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 18.0625H23.375"
        stroke="black"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.25 27.625V7.4375C4.25 7.15571 4.36194 6.88546 4.5612 6.6862C4.76046 6.48694 5.03071 6.375 5.3125 6.375H28.6875C28.9693 6.375 29.2395 6.48694 29.4388 6.6862C29.6381 6.88546 29.75 7.15571 29.75 7.4375V27.625L25.5 25.5L21.25 27.625L17 25.5L12.75 27.625L8.5 25.5L4.25 27.625Z"
        stroke="black"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6772_140962">
        <rect width={34} height={34} fill="white" />
      </clipPath>
    </defs>
  </svg>
  );
};
